import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import FeaturedVideos from './components/FeaturedVideos';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    document.title = '欲火视频 - 热门影视资源在线观看平台';

    const setMeta = (name: string, content: string, propName?: string) => {
      let el: HTMLMetaElement | null;
      if (propName) {
        el = document.querySelector(`meta[property="${propName}"]`);
      } else {
        el = document.querySelector(`meta[name="${name}"]`);
      }
      if (!el) {
        el = document.createElement('meta');
        if (propName) {
          el.setAttribute('property', propName);
        } else {
          el.setAttribute('name', name);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '欲火视频是专业的在线视频平台，提供海量高清影视资源、热门剧集、电影大片及短视频内容，欲火视频让您随时随地畅享极致视听体验，支持多终端流畅播放，每日更新最新内容。');
    setMeta('keywords', '欲火视频,欲火视频在线观看,欲火视频高清资源,欲火视频最新剧集,欲火视频电影大全,欲火视频免费播放,欲火视频手机版');

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', window.location.origin + '/');
  }, []);

  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '欲火视频',
        url: window.location.origin,
        description: '欲火视频是专业的在线视频平台，提供海量高清影视资源、热门剧集、电影大片及短视频内容。',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '400-888-8888',
          contactType: 'customer service',
          availableLanguage: 'Chinese',
        },
      },
      {
        '@type': 'WebSite',
        name: '欲火视频',
        url: window.location.origin,
        description: '欲火视频 - 热门影视资源在线观看平台',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${window.location.origin}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '欲火视频首页',
        description: '欲火视频是专业的在线视频平台，提供海量高清影视资源、热门剧集、电影大片及短视频内容。',
        url: window.location.origin + '/',
        isPartOf: {
          '@type': 'WebSite',
          name: '欲火视频',
          url: window.location.origin,
        },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '欲火视频需要付费吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '欲火视频提供大量免费影视资源供用户在线观看。部分最新院线大片和独家内容可能需要会员订阅，但平台每天都会更新大量免费内容。',
            },
          },
          {
            '@type': 'Question',
            name: '欲火视频支持哪些设备观看？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '欲火视频支持多终端流畅播放，包括电脑网页版、手机浏览器、平板设备等，无需下载任何软件即可开始观看。',
            },
          },
          {
            '@type': 'Question',
            name: '欲火视频的内容更新频率如何？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '欲火视频每日更新最新影视内容，包括热门剧集同步更新、新上映电影第一时间上线、综艺节目及时跟进等。',
            },
          },
          {
            '@type': 'Question',
            name: '欲火视频的画质如何？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '欲火视频提供高清甚至超高清画质的影视资源，支持自适应码率技术，根据网络状况自动调整播放画质。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <main>
        <HeroSection />
        <CategoryQuickLinks />
        <FeaturedVideos />
        <LatestArticles />
        <FAQSection />
      </main>
    </>
  );
}